(function () {
    var pauseButton = document.getElementById("pauseButton");

    if (pauseButton) {
        pauseButton.addEventListener("click", function () {
            var video = document.getElementById("heroVideo");
            var icon = this.querySelector('i');

            if (video.paused) {
                video.play();
                icon.className = "fas fa-pause";
                this.setAttribute("aria-label", "Pause Video");
            } else {
                video.pause();
                icon.className = "fas fa-play";
                this.setAttribute("aria-label", "Play Video");
            }
        });
    }
}());